import React from "react";

import { useSidebar } from "./hooks/useSidebar";

interface SidebarFooterProps {
  className?: string;
  children: React.ReactNode;
}

/**
 * SidebarFooter - Sticky footer section at the bottom of the sidebar
 *
 * @param className - Additional CSS classes
 * @param children - Footer content
 */
export function SidebarFooter({
  className = "",
  children,
}: SidebarFooterProps) {
  const { state } = useSidebar();
  const isCollapsed = state === "collapsed";

  return (
    <div
      className={`
        flex flex-col gap-xs py-md transition-[padding] duration-200
        border-0 border-t border-solid border-primary
        shrink-0
        ${isCollapsed ? "px-xs" : "px-md"}
        ${className}
      `.trim()}
      data-state={state}
    >
      {children}
    </div>
  );
}
